import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card.tsx';
import { useRunOnce } from '@/hooks/use-run-once';
import { useSessionSave } from '@/hooks/use-session-save';
import { setExitMilestone } from '@/hooks/use-session-store/use-session-store';
import { endTrackingSession } from '@/lib/analytics';
import { SUPPORT_PHONE_DISPLAY } from '@/lib/constants.ts';
import { MILESTONES } from '@/lib/wizard/milestones';

export function InsuranceReachOut() {
  const { saveSession } = useSessionSave();

  useRunOnce(() => {
    setExitMilestone(MILESTONES.REACH_OUT_PENDING);
    saveSession();
    endTrackingSession();
  });

  return (
    <section>
      <Card>
        <CardHeader>
          <CardTitle className="text-center">
            Great, we'll reach out to confirm your request in 24hrs!
          </CardTitle>
        </CardHeader>

        <CardContent>
          <p className="text-center">
            If you need supplies sooner, please give us a call at {SUPPORT_PHONE_DISPLAY}.
          </p>
        </CardContent>
      </Card>
    </section>
  );
}
